import { Component } from "@angular/core";
@Component({
    selector: "shell-app",
    template: `<h3>ZBD Frontend Version {{ buildVersion }}</h3>`,
})
export class VersionComponent {
    public buildVersion;

    constructor() {
        this.buildVersion = version.BUILD_VERSION;
    }
}
